import { useContext } from 'react';
import { DraftContext } from './DraftContext';

export const draftEventTypes = {
  EXIT: 'EXIT',
  DISMISS: 'DISMISS',
  PUBLISH: 'PUBLISH',
  PUBLISH_CONFIRM: 'PUBLISH_CONFIRM',
} as const;

export function useDraftContext() {
  return useContext(DraftContext);
}
